"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _noop2 = _interopRequireDefault(require("lodash/noop"));

var _atoms = require("../../components/atoms");

var Icons = _interopRequireWildcard(require("../../components/atoms/Icons"));

var _Form = require("../../components/organisms/Form");

var _hocs = require("../../hocs");

var _config = _interopRequireDefault(require("./config"));

require("./Login.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function Login(_ref) {
  var _ref$login = _ref.login,
      login = _ref$login === void 0 ? _noop2.default : _ref$login,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? false : _ref$error,
      _ref$resetLogin = _ref.resetLogin,
      resetLogin = _ref$resetLogin === void 0 ? _noop2.default : _ref$resetLogin,
      _ref$form = _ref.form,
      form = _ref$form === void 0 ? {} : _ref$form;
  var handleSubmit = form.handleSubmit,
      control = form.control;
  var onSubmit = (0, _react.useCallback)(function (values) {
    resetLogin();
    login(values);
  }, [login, resetLogin]);
  var resetForm = (0, _react.useCallback)(function () {
    resetLogin();
  }, [resetLogin]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "page-login"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, loading && !error ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "grid grid-cols-1 place-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: ""
  }, /*#__PURE__*/_react.default.createElement(Icons.Logo, {
    className: "page-login-scaling",
    width: "100%",
    height: "100%"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "grid grid-cols-1 place-items-center"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "text-white text-center text-xl"
  }, "Cargando..."))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "grid grid-cols-1 place-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "w-64 sm:w-80 md:w-5/12 max-w-sm"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "page-login-form"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "grid grid-cols-1 place-items-center page-login-form-top"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex content-center"
  }, /*#__PURE__*/_react.default.createElement(Icons.Logo, {
    width: "6.25rem"
  }))), /*#__PURE__*/_react.default.createElement("h1", {
    className: "text-2xl text-center sub uppercase font-extrabold"
  }, "Iniciar sesi\xF3n"), /*#__PURE__*/_react.default.createElement("p", {
    className: "text-center mt-1"
  }, "Antes de continuar, por favor ingresa tu usuario y contrase\xF1a"), /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/_react.default.createElement(_Form.FormInput, {
    name: "username",
    label: "Usuario",
    control: control
  }), /*#__PURE__*/_react.default.createElement(_Form.FormPasswordInput, {
    name: "password",
    label: "Contrase\xF1a",
    control: control,
    onBlur: resetForm,
    type: "password"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "my-5 grid place-items-center"
  }, /*#__PURE__*/_react.default.createElement(_atoms.ActionLink, null, "Olvid\xE9 mi contrase\xF1a")), /*#__PURE__*/_react.default.createElement(_atoms.Button, {
    block: true,
    type: "submit"
  }, "Aceptar"))))))));
}

Login.propTypes = {
  login: _propTypes.default.func,
  loading: _propTypes.default.bool,
  error: _propTypes.default.bool,
  resetLogin: _propTypes.default.func,
  form: _propTypes.default.shape({
    handleSubmit: _propTypes.default.func,
    control: _propTypes.default.object
  })
};

var _default = (0, _hocs.withForm)(_config.default)(Login);

exports.default = _default;